export default __webpack_public_path__ + "static/media/Arrow_return.868c9332.svg";